import lazySizes from 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/bgset/ls.bgset';

if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
  var respimg = () => import('lazysizes/plugins/respimg/ls.respimg');

  respimg();
}

var options = {
  expFactor: 1,
  loadHidden: false,
  loadMode: 1,
  customMedia: {
    '--xs': '(max-width: 576px)',
    '--sm': '(max-width: 768px)',
    '--md': '(max-width: 992px)',
    '--lg': '(max-width: 1440px)'
  }
};
Object.assign(lazySizes.cfg, options);